import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
    const { t } = useTranslation();
    return (
        <main
            data-testid="privacy-page"
            className="min-h-[calc(100vh-73px)] max-w-3xl mx-auto px-5 md:px-10 py-12 md:py-20"
        >
            <Link
                to="/"
                data-testid="privacy-back-link"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[var(--ink-muted)] hover:text-[var(--accent)] mb-8"
            >
                <ArrowLeft size={14} strokeWidth={1.5} />
                {t("legal.back")}
            </Link>
            <p className="text-xs uppercase tracking-[0.3em] text-[var(--accent)] mb-3">
                {t("privacy.eyebrow")}
            </p>
            <h1
                className="font-display text-4xl md:text-5xl text-[var(--ink)] tracking-tight mb-10"
                style={{ fontVariationSettings: '"wght" 700, "wdth" 80, "opsz" 144' }}
            >
                {t("privacy.title")}
            </h1>

            <div className="prose-invert space-y-6 text-[var(--ink-muted)] leading-relaxed">
                <Section title={t("privacy.s1_title")} body={t("privacy.s1_body")} />
                <Section title={t("privacy.s2_title")} body={t("privacy.s2_body")} />
                <Section title={t("privacy.s3_title")} body={t("privacy.s3_body")} />
                <Section title={t("privacy.s4_title")} body={t("privacy.s4_body")} />
                <Section title={t("privacy.s5_title")} body={t("privacy.s5_body")} />
                <Section title={t("privacy.s6_title")} body={t("privacy.s6_body")} />
                <p className="text-xs text-[var(--ink-dim)] pt-6 border-t border-[var(--border)]">
                    {t("privacy.last_updated")}
                </p>
            </div>
        </main>
    );
}

function Section({ title, body }) {
    return (
        <section>
            <h2 className="font-display text-2xl text-[var(--ink)] mb-3">{title}</h2>
            <p className="text-[var(--ink-muted)] whitespace-pre-line">{body}</p>
        </section>
    );
}
